import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawBoomModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Boom");

		this.name = "boom";
		this.icon = svg_boom;
		this.svgTextIndex = 1;
	}
}

window.customElements.define("inspx-draw-boom-module", DrawBoomModule);

const svg_boom = (text) => html`
<svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <ellipse transform="matrix(0.9850207259336877,0,0,0.9612932829150439,-75.92824466375347,14.674185666089379) " fill="#008000" stroke="#050000" stroke-width="2.08293" stroke-linecap="round" stroke-miterlimit="4" stroke-dashoffset="0" ry="23.10802" rx="23.18334" cy="11.09971" cx="102.65211" id="path3343-2"/>
 <text xml:space="preserve" text-anchor="middle" font-family="Arial" font-size="12.8px" id="svg_1" y="29.02247" x="25.17798" stroke-linecap="round" stroke-linejoin="null" stroke-dasharray="null" stroke-width="1.06667" stroke="#050000" fill="#000000">${text}</text>
</g>
</svg>
`;
